<template>
  <div class="sliders-container">
    <!-- Main slider -->
    <div class="main-slider-wrapper mobile-slider-wrapper">
      <SoldMarked :color="color" v-if="sold_at || color ==='red'" class="sold-marker sold-marker_desktop" />
      <SoldMarkedMobile :color="color" v-if="sold_at|| color ==='red'" class="sold-marker sold-marker_mobile" />
      <div class="main-slider-container" :class="{ 'is-sold': sold_at || color ==='red' }">
        <splide
          ref="primary"
          :options="primaryOptions"
          class="mobile-image-primary-slide"
        >
          <splide-slide
            v-for="slide in transformedSlides"
            :key="slide.id"
            indicator-position="outside"
            v-lazy-container="{ selector: 'img' }"
          >
            <img
              :data-src="slide.path"
              :alt="slide.name"
              :style="{ objectFit: slide.objectFit }"
            />
          </splide-slide>
        </splide>
      </div>
    </div>
    <!-- Thumbnail slider -->
    <div class="thumbnail-slider-wrapper hidden-xs-only">
      <splide ref="secondary" :options="secondaryOptions">
        <splide-slide v-for="slide in transformedSlides" :key="slide.id">
          <img :src="slide.path" :alt="slide.name" />
        </splide-slide>
      </splide>
    </div>
  </div>
</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import SoldMarked from '@/components/icons/SoldMarked'
import SoldMarkedMobile from '@/components/icons/SoldMarkedMobile'

export default {
  name: 'ApartmentSlider',
  components: { SoldMarkedMobile, SoldMarked, Splide, SplideSlide },
  props: {
    slides: Array,
    sold_at: String,
    color: String
  },
  mounted() {
    this.$refs.primary.sync(this.$refs.secondary.splide)
  },
  computed: {
    transformedSlides() {
      return this.slides.map((item) => {
        const url = item.path
        return {
          ...item,
          objectFit: this.setImgFit(url),
        }
      })
    },
  },

  data() {
    return {
      primaryOptions: {
        width: 800,
        fixedHeight: 455,
        type: 'loop',
        perPage: 1,
        perMove: 1,
        gap: '1rem',
        pagination: window.innerWidth < 500 ? true : false,
        updateOnMove: true,
      },
      secondaryOptions: {
        type: 'slide',
        rewind: true,
        gap: '1.2rem',
        pagination: false,
        fixedWidth: 100,
        fixedHeight: 70,
        cover: true,
        focus: 'center',
        isNavigation: true,
        updateOnMove: true,
        padding: {
          left: '1rem',
          right: '1rem',
        },
      },
      count: 0,
    }
  },
  methods: {
    setImgFit(url) {
      let result
      const img = new Image()
      img.src = url
      img.onload = function () {
        this.width > this.height ? (result = 'fill') : (result = 'contain')
      }
      img.onload()
      return result
    },
    hey() {
      console.log('here')
    },
  },
}
</script>

<style lang="scss">
.splide__pagination {
  top: 102%;
}
.splide__pagination__page {
  width: 4px !important ;
  height: 4px !important;
}
.splide__pagination__page.is-active {
  transform: scale(1.6) !important;
  background-color: #5ac2f2 !important;
}
.sliders-container {
  .main-slider-wrapper {
    position: relative;
    padding: 1rem;
    background-color: #fff;
    margin-right: 4rem;
    margin-bottom: 2.2rem;
    border-radius: 2.2rem;
    box-shadow: 0 0 17px 0 rgba(100, 98, 117, 0.07);

    .sold-marker {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 10;
      &_mobile {
        display: none;
      }
    }
    .main-slider-container {
      &.is-sold {
        opacity: 0.7;
      }
      .splide__slide img {
        border-radius: 1.8rem;
        width: 100%;
        height: 100%;
      }

      .splide__arrow {
        width: 4.6rem;
        height: 4.6rem;
        background-color: #fff;
        opacity: 1;

        svg {
          width: 10px;
          height: 10px;
          fill: #b5c9d3;
        }
      }
    }
  }

  .thumbnail-slider-wrapper {
    margin-right: 4rem;

    .splide__arrows {
      display: none;
    }
    //causes thumbnail unstable work
    //.splide__list {
    //  transform: translateX(0) !important;
    //}

    .splide__track {
      padding: 1rem 0;
    }

    .splide--nav > .splide__track > .splide__list > .splide__slide {
      height: 6.9rem !important;
      width: 10.6rem !important;
      border-radius: 1.8rem;
      border: none;
      position: relative;
      cursor: pointer;

      &:last-child {
        margin-right: 0;
      }

      &.is-active {
        &:before {
          content: '';
          position: absolute;
          width: 11.4rem;
          height: 7.7rem;
          border: 1px solid #b5c9d4;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          border-radius: 2.2rem;
        }
      }
    }
  }
}
@media (min-width: 500px) {
  .splide__track {
    border-radius: 1.8rem;
  }
}
@media (max-width: 500px) {
  .main-slider-wrapper.mobile-slider-wrapper {
    margin-right: 0px;
    height: 100%;

    padding: 0;
  }
  .splide__arrows {
    display: none;
  }
  //   .sliders-container {
  //   .main-slider-wrapper {

  .main-slider-container {
    border-radius: 12px;
  }
  .main-slider-wrapper {
    .sold-marker {
      &_desktop {
        display: none;
      }
      &_mobile {
        display: block !important;
      }
    }
    .mobile-image-primary-slide {
      .splide__slide {
        max-height: 240px !important;
      }
      img {
        object-fit: cover !important;
      }
    }
  }
}
</style>
